/** Calls the logout route, then reloads the current page. Extracted so it can be mocked in tests without touching window.location. */
export const navigateToLogout = async (logoutUrl: string) => {
    await fetch(logoutUrl, { credentials: "include" });
    window.location.reload();
};
